var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBookingDetails = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "-2 -2 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.93 12.3347 0.93 12.3347 12.434 0 12.434"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 16 16 16 16 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.5-Create-Class-/-Settings",
    transform: "translate(-64.000000, -243.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cells-/-Small-Image",
    transform: "translate(42.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "currentColor",
    points: "2.211 2.471 3.023 2.471 3.023 0 2.211 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "currentColor",
    points: "9.305 2.471 10.116 2.471 10.116 0 9.305 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0003,0.93 L-0.0003,12.434 L8.7197,12.434 C8.6787,12.261 8.6687,12.087 8.6687,11.904 C8.6687,11.812 8.6687,11.71 8.6877,11.618 L0.8107,11.618 L0.8107,1.745 L11.5237,1.745 L11.5237,8.654 C11.6557,8.633 11.7877,8.623 11.9297,8.623 C12.0707,8.623 12.2027,8.633 12.3347,8.654 L12.3347,0.93 L-0.0003,0.93 Z",
    id: "Fill-3",
    fill: "#383E41",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "currentColor",
    mask: "url(#mask-4)",
    points: "0.496 3.814 11.927 3.814 11.927 2.999 0.496 2.999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9294,15.1849 C10.3094,15.1849 8.9614,13.9929 8.7194,12.4339 C8.6784,12.2609 8.6684,12.0869 8.6684,11.9039 C8.6684,11.8119 8.6684,11.7099 8.6884,11.6189 C8.8104,10.0699 10.0044,8.8369 11.5244,8.6539 C11.6564,8.6329 11.7874,8.6229 11.9294,8.6229 C12.0714,8.6229 12.2024,8.6329 12.3344,8.6539 C13.9444,8.8469 15.1904,10.2329 15.1904,11.9039 C15.1904,13.7179 13.7314,15.1849 11.9294,15.1849 M12.3344,7.8289 C12.2024,7.8179 12.0714,7.8079 11.9294,7.8079 C11.7874,7.8079 11.6564,7.8179 11.5244,7.8289 C9.5594,8.0219 7.9994,9.6219 7.8584,11.6189 C7.8484,11.7099 7.8484,11.8119 7.8484,11.9039 C7.8484,12.0869 7.8584,12.2609 7.8884,12.4339 C8.1414,14.4519 9.8634,15.9999 11.9294,15.9999 C14.1774,15.9999 15.9994,14.1659 15.9994,11.9039 C15.9994,9.7849 14.3904,8.0319 12.3344,7.8289",
    id: "Fill-8",
    fill: "#383E41",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "currentColor",
    mask: "url(#mask-4)",
    points: "11.524 10.767 12.335 10.767 12.335 9.886 11.524 9.886"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "currentColor",
    mask: "url(#mask-4)",
    points: "11.524 13.749 12.335 13.749 12.335 11.166 11.524 11.166"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookingDetails, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookingDetails.a7d6c355.svg";
export { ForwardRef as ReactComponent };